import {
  StringSetting,
  useUserSettingWithDefault,
  UseUserSettingWithDefaultReturnType,
} from "shared-ts-utils-user-settings";
import { ThemeName } from "./ThemeName";

export const useThemeUserSettingWithDefault = (defaultTheme: ThemeName) => {
  return useUserSettingWithDefault("theme", StringSetting, defaultTheme, {
    storeLocally: true,
    storeCopyToAppLocally: true,
  }) as UseUserSettingWithDefaultReturnType<ThemeName>;
};
